import { Box, Button, Paper, Typography } from "@mui/material";
import { SvgIconComponent } from "@mui/icons-material";
import { ReactNode } from "react";

type EmptyStateProps = {
  title: string;
  description: string;
  icon: SvgIconComponent;
  action?: ReactNode;
  compact?: boolean;
};

const EmptyState = ({
  title,
  description,
  icon: Icon,
  action,
  compact = false,
}: EmptyStateProps) => (
  <Paper
    variant="outlined"
    sx={{
      minHeight: compact ? 220 : 320,
      width: "100%",
      display: "grid",
      placeItems: "center",
      p: 3,
      borderRadius: "18px",
      borderStyle: "dashed",
      boxShadow: "none",
      bgcolor: "transparent",
    }}
  >
    <Box sx={{ maxWidth: 430, textAlign: "center" }}>
      <Box
        sx={{
          width: 64,
          height: 64,
          display: "grid",
          placeItems: "center",
          mx: "auto",
          mb: 2,
          borderRadius: "20px",
          color: "accentText",
          bgcolor: "rgba(99,91,255,.10)",
          "& svg": { fontSize: 31 },
        }}
      >
        <Icon />
      </Box>
      <Typography variant="h6" sx={{ mb: 0.75 }}>
        {title}
      </Typography>
      <Typography color="text.secondary" fontSize={14}>
        {description}
      </Typography>
      {action && <Box sx={{ mt: 2.5 }}>{action}</Box>}
    </Box>
  </Paper>
);

export const EmptyStateAction = Button;
export default EmptyState;
